import { createUseStyles } from 'react-jss';

export default createUseStyles({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%',
    margin: 15,
    marginBottom: 10,

    '& > button': {
      margin: '0 8px',
      borderRadius: '10px',
      height: 36,
      width: 130,
      fontSize: '14px',
    },
    '& > button:focus': {
      outline: 0,
    },

    '@media(max-width: 900px)': {
      margin: 0,
      '& > button': {
        width: '100%',
        margin: '2px 0px',
      },
    }
  },

  button: {
    border: '1px solid silver',
    backgroundColor: 'transparent',
    color: '#blue',
    '&:hover': {
      backgroundColor: '#C8D8E1',
    },
  },

  activeButton: {
    backgroundColor: '#38526B',
    boxShadow: '0 0 18px 0 rgba(0,0,0,0.16)',
    color: '#DEDEDE',
    fontWeight: 600,
  },

  buttonGroupTitle: {
    fontSize: '16px',
    fontWeight: '600',
    paddingLeft: '20px',
  },
});
